<h1 class="title">{{ data.title }}</h1>
@if (data.isDuplicate) {
<div class="description">
  <p>{{ data.description }}</p>
</div>
}

<form [formGroup]="diagFormGroup" (ngSubmit)="submit()">
  <div>
    @for (error of errors; track error) {
    <div class="error">
      {{ error?.message }}
    </div>
    }
  </div>
  <div class="form-control-name">
    @if (data.isDuplicate) {
    <label>
      {{ 'platform.ui.components.application.bar.label.duplicate.project.name' | translate }}
      <span class="required">*</span>
    </label>
    }
    <input
      type="text"
      class="form-control"
      formControlName="name"
      [attr.disabled]="loading ? true : null"
    />
  </div>
  @if (data.isDuplicate) {
  <div>
    <mat-checkbox
      strong
      formControlName="includeAllCollaborators"
      [attr.disabled]="loading ? true : null"
    >
      {{
        'platform.ui.components.application.bar.label.duplicate.project.include.all.collaborators'
          | translate
      }}
    </mat-checkbox>
  </div>
  }

  <div class="footer">
    <button
      mat-button
      color="secondary"
      small
      id="cancel-btn"
      type="button"
      [disabled]="loading"
      (click)="close()"
    >
      {{ 'platform.ui.components.label.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      small
      id="done-btn"
      type="submit"
      [disabled]="loading || !diagFormGroup.valid"
    >
      {{ data.doneButtonLabel }}
    </button>
  </div>
</form>
@if (loading) {
<mat-progress-spinner
  color="secondary"
  diameter="100"
  mode="indeterminate"
  value="50"
></mat-progress-spinner>
}
